var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.8401,
    y1: 0.7692,
    x2: 8.5903,
    y2: 21.6267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#f2612b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 29.0827,
    y1: 0.7338,
    x2: 29.2348,
    y2: 21.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#f2612b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 49.2361,
    y1: 1.0325,
    x2: 49.2369,
    y2: 21.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#f2612b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 60.3548,
    y1: 1.1232,
    x2: 60.5431,
    y2: 21.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#f2612b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 73.2598,
    y1: 0.7878,
    x2: 73.3661,
    y2: 21.6268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8873,
    stopColor: "#f2612b"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M.5369,15.3431h5.43c0,1.1658,1.2577,2.1168,2.8222,2.1168,1.4113,0,2.577-.7363,2.577-1.6872,0-2.853-10.4916-1.6566-10.4916-8.8351C.8744,2.9189,4.2489.25,8.6358.25c4.4482,0,7.8226,2.7916,7.8226,6.5342h-5.3992c0-1.043-1.0737-1.8406-2.4848-1.8406-1.2271,0-2.3008.6135-2.3008,1.5952,0,2.9143,10.5222,1.2578,10.5222,8.6203,0,4.2335-3.5279,6.9945-8.0681,6.9945-4.6937,0-8.191-2.9758-8.191-6.8105Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.931,11.2018C17.931,4.9743,22.7473.25,29.159.25c6.3809,0,11.2279,4.7243,11.2279,10.9518s-4.847,10.9518-11.2279,10.9518c-6.4116,0-11.228-4.7243-11.228-10.9518ZM34.957,11.2018c0-3.3438-2.5156-5.8594-5.798-5.8594-3.3132,0-5.8288,2.5156-5.8288,5.8594s2.5156,5.8593,5.8288,5.8593c3.2825,0,5.798-2.5154,5.798-5.8593Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5338.6181h5.2766v16.1976h8.1294v4.9698h-13.406V.6181Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8108.6181h5.2766v21.1673h-5.2766V.6181Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2041,15.3431h5.43c0,1.1658,1.2577,2.1168,2.8222,2.1168,1.4113,0,2.577-.7363,2.577-1.6872,0-2.853-10.4916-1.6566-10.4916-8.8351,0-4.0187,3.3745-6.6876,7.7614-6.6876,4.4482,0,7.8226,2.7916,7.8226,6.5342h-5.3992c0-1.043-1.0737-1.8406-2.4848-1.8406-1.2271,0-2.3008.6135-2.3008,1.5952,0,2.9143,10.5222,1.2578,10.5222,8.6203,0,4.2335-3.5279,6.9945-8.0681,6.9945-4.6937,0-8.191-2.9758-8.191-6.8105Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0384,29.2854v2.3838h-.994v-5.6567h.994v2.3515h2.6991v-2.3515h.994v5.6567h-.994v-2.3838h-2.6991Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7935,26.9014h-3.2001v1.4708h2.8364v.8889h-2.8364v1.5193h3.2405v.8889h-4.2344v-5.6567h4.1941v.8889Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8417,31.6692h-1.0506l-.5738-1.3657h-2.6749l-.5818,1.3657h-1.0182l2.489-5.6971h.9212l2.489,5.6971ZM18.8759,27.1601l-.9698,2.2627h1.9476l-.9778-2.2627Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2246,26.0126h.994v4.7516h2.9738v.905h-3.9678v-5.6567Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2243,31.6692h-1.002v-4.7354h-1.794v-.9212h4.5899v.9212h-1.7939v4.7354Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4762,29.2854v2.3838h-.994v-5.6567h.994v2.3515h2.6991v-2.3515h.994v5.6567h-.994v-2.3838h-2.6991Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9925,29.851h-1.1232v1.8182h-.994v-5.6567h2.2303c1.3172,0,2.1497.7435,2.1497,1.899,0,1.2767-1.0183,1.9394-2.2628,1.9394ZM50.0248,26.9176h-1.1555v2.0364h1.1555c.7515,0,1.2203-.4121,1.2203-1.0182,0-.6707-.4768-1.0182-1.2203-1.0182Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6868,26.0126h.994v4.7516h2.9738v.905h-3.9678v-5.6567Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5168,31.6692h-1.0506l-.5738-1.3657h-2.6749l-.5818,1.3657h-1.0182l2.489-5.6971h.9212l2.489,5.6971ZM63.5511,27.1601l-.9698,2.2627h1.9476l-.9778-2.2627Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8514,26.0126h.9778v5.6567h-.8323l-3.1193-4.0243v4.0243h-.9778v-5.6567h.9212l3.0304,3.9112v-3.9112Z",
    style: {
      fill: "#545759"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8791,28.3884c1.1959.2909,1.8182.7191,1.8182,1.6647,0,1.0666-.8324,1.6969-2.0203,1.6969-.8646,0-1.6808-.2989-2.3596-.905l.598-.7111c.5415.4686,1.0829.7353,1.786.7353.6141,0,1.002-.2829,1.002-.7191,0-.4122-.2263-.6303-1.2768-.8728-1.2041-.2909-1.8828-.6465-1.8828-1.6969,0-.986.8081-1.6487,1.9314-1.6487.8243,0,1.4788.2506,2.0526.7112l-.5334.7515c-.509-.3798-1.0182-.5819-1.5354-.5819-.5818,0-.9212.299-.9212.6789,0,.4444.2585.6384,1.3414.897Z",
    style: {
      fill: "#545759"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolisLogo);
export default __webpack_public_path__ + "static/media/solis_logo.a6a7bfa5dfe7bad04f230381f909f038.svg";
export { ForwardRef as ReactComponent };